// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"cecfdefd","431":"80080fba","795":"6a4824cc"}[chunkId] + ".chunk.css";
};